module.exports = __webpack_public_path__ + "img/upload-o.ec59d9b7.svg";